/**
 * Generate a URL-friendly slug from vehicle data
 * Format: year-make-model-id (e.g., 2024-porsche-911-carrera-6949)
 */
export function generateVehicleSlug(vehicle: {
  id: number;
  year?: number;
  make?: string;
  model?: string;
}): string {
  const parts: string[] = [];
  
  if (vehicle.year) {
    parts.push(String(vehicle.year));
  }
  
  if (vehicle.make) {
    parts.push(vehicle.make.toLowerCase().replace(/[^a-z0-9]+/g, '-'));
  }
  
  if (vehicle.model) {
    // Take first 3 words of model to keep URL reasonable
    const modelSlug = vehicle.model
      .toLowerCase()
      .replace(/[^a-z0-9\s]+/g, '')
      .split(/\s+/)
      .slice(0, 3)
      .join('-');
    parts.push(modelSlug);
  }
  
  // Always append the ID at the end
  parts.push(String(vehicle.id));
  
  return parts.join('-');
}

/**
 * Extract the vehicle ID from a slug
 * The ID is always the last number in the slug
 */
export function extractIdFromSlug(slug: string): number | null {
  // The ID is the last segment after the final dash
  const match = slug.match(/-(\d+)$/);
  if (match) {
    return parseInt(match[1], 10);
  }
  
  // Fallback: if slug is just a number, return it
  const numericId = parseInt(slug, 10);
  if (!isNaN(numericId)) {
    return numericId;
  }
  
  return null;
}

